module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    class: ['loading-container', _vm.showLoading && _vm.needMask && 'loading-need-mask'],
    style: (_vm._px2rem(_vm.maskStyle, 75)),
    attrs: {
      "weex-type": "div",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.maskClicked($event)
      }
    }
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: "wxc-loading weex-ct weex-div",
    style: ({
      top: _vm._px2rem(_vm.topPosition + 'px', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: " weex-ct weex-div",
    class: ['loading-box', _vm.loading.class],
    attrs: {
      "aria-hidden": true,
      "weex-type": "div"
    }
  }, [_c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    staticClass: "loading-trip-image weex-el weex-image",
    attrs: {
      "src": _vm.loadingPic || _vm.loading.url,
      "resize": "contain",
      "quality": "original",
      "data-img-src": _vm.loadingPic || _vm.loading.url,
      "weex-type": "image"
    }
  }), _vm._v(" "), (_vm.loadingText) ? _c('p', {
    staticClass: "loading-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.loadingText))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a148edb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a148edb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-loading/index.vue
// module id = 212
// module chunks = 0 1